import ModuleContent from './ModuleContent';

export default ModuleContent;
